import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { BookmarkSortModel } from '../../models/bookmark-sort.model';

export const bookmarkSortRecent: BookmarkSortModel = {
  label: 'Most Recent',
  field: 'update_date_time',
  alias: 'create_date_time',
  ascending: false
};

export const bookmarkSortTitleAsc: BookmarkSortModel = {
  label: 'Title (A-Z)',
  field: 'title',
  ascending: true
};

export const bookmarkSortTitleDesc: BookmarkSortModel = {
  label: 'Title (Z-A)',
  field: 'title',
  ascending: false
};

export const bookmarkSortAuthorAsc: BookmarkSortModel = {
  label: 'Author (A-Z)',
  field: 'author',
  ascending: true
};

export const bookmarkSortAuthorDesc: BookmarkSortModel = {
  label: 'Author (Z-A)',
  field: 'author',
  ascending: false
};

export const bookmarkSortOrders: BookmarkSortModel[] = [
  bookmarkSortRecent,
  bookmarkSortTitleAsc,
  bookmarkSortTitleDesc,
  bookmarkSortAuthorAsc,
  bookmarkSortAuthorDesc
];

@Component({
  selector: 'app-bookmarks-sort',
  templateUrl: './bookmarks-sort.component.html',
  styleUrls: ['./bookmarks-sort.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookmarksSortComponent implements OnInit {
  bookmarkSort = bookmarkSortOrders;

  @Input()
  selection: BookmarkSortModel = bookmarkSortOrders[0];

  @Output()
  sort = new EventEmitter<BookmarkSortModel>();

  constructor() { }

  ngOnInit() {
  }

  handleItemClick(item: BookmarkSortModel) {
    this.sort.emit(item);
  }

}
